export default __webpack_public_path__ + "static/media/Cross-icon-45x45.5d163512.svg";